<ng-container>
    <div class="mx-5 my-4 user-config-container">
        <form [formGroup]="userConfigForm">
            <div class="px-2 mt-6">
                <div class="row mb-3">
                    <div class="col-12 col-md-6 form-container align-self disabled-div">
                        <input type="checkbox" class="form-check-input me-2" formControlName="isEmailverified" name="isEmailverified"
                        [checked]="userConfigForm.get('isEmailverified')?.value === 1" /> 
                        <label class="form-check-label mt-1 ms-1 text-black"> Email Verified - Checked After First-Time Password Setup</label>
                    </div>
                    <div class="col-12 col-md-6">
                        <button mat-button type="submit" (click)="onSetupLink()" class="btn btn-sm btn-light-primary button-wdith">Send Setup Link</button>
                    </div>
                </div>
                <div class="row mb-3">
                    <div class="col-12 col-md-6 form-container align-self disabled-div">
                        <input type="checkbox" class="form-check-input me-2" formControlName="isResetVerified" name="isResetVerified" 
                        [checked]="userConfigForm.get('isResetVerified')?.value === 1" /> 
                        <label class="form-check-label mt-1 ms-1 text-black">Password Reset Verified - Checked After Forgot & Reset Password</label>
                    </div>
                    <div class="col-12 col-md-6">
                        <button mat-button type="submit" (click)="onResetLink()" class="btn btn-sm btn-light-primary button-wdith">Send Reset Link</button> 
                    </div>
                </div>
                <div class="row mb-3">
                    <div class="col-12 col-md-6 form-container align-self mt-3 disabled-div">
                        <input type="checkbox" class="form-check-input me-2" formControlName="isQrValidated" name="isQrValidated" 
                        [checked]="userConfigForm.get('isQrValidated')?.value === 1" /> 
                        <label class="form-check-label mt-1 ms-1 text-black">Multi-Factor Authentication (MFA) Verified via QR Code</label>
                    </div>
                    <div class="col-12 col-md-6">
                        <button mat-button type="submit" (click)="onQrLink()" class="btn btn-sm btn-light-primary button-wdith">Reset MFA</button>
                    </div>
                </div>
                <div class="row mb-3">
                    <div class="col-12 col-md-6 form-container align-self mt-5 disabled-div">
                        <input type="checkbox" class="form-check-input me-2" formControlName="isLocked" name="isLocked" 
                        [checked]="userConfigForm.get('isLocked')?.value === 1"/> 
                        <label class="form-check-label mt-1 ms-1 text-black">User Locked Due to Consecutive Failed Login Attempts</label>
                    </div>
                    <div class="col-12 col-md-6">
                        <button mat-button type="submit" (click)="onSystemLock()" [disabled]="this.isLocked()" class="btn btn-sm btn-light-primary button-wdith">Unlock User</button>
                    </div>
                </div>
                <div class="row mb-3">
                    <div class="col-12 col-md-6 form-container align-self mt-5 disabled-div session-div">
                        <!-- <input type="checkbox" class="form-check-input me-2" formControlName="resetSession" name="resetSession" 
                        [checked]="userConfigForm.get('resetSession')?.value === 1"/>  -->
                        <label class="form-check-label mt-1 ms-1 text-black">Resets the user's session and allows re-login.</label>
                    </div>
                    <div class="col-12 col-md-6 session">
                        <button mat-button type="submit" (click)="onResetSession()"  class="btn btn-sm btn-light-primary button-wdith">Reset Session</button>
                    </div>
                </div>
            </div>                                    
        </form>
    </div>
    <!-- <mat-action-row class="accordion-footer d-flex justify-content-end py-5 px-6">
        <button mat-button type="button" (click)="onCancel()"  class="btn btn-lg btn-light-primary me-3 back-btn">Cancel</button>
        <div [attr.title]="this.userConfigForm.invalid ? 'Please fix the errors in the form.' : null">
            <button mat-button type="submit" (click)="onSubmit()"  [disabled]="this.userConfigForm.invalid" class="btn btn-lg btn-primary continue-btn">{{ isCreateUser ? 'Create' : 'Save' }}</button>                                                      
        </div>
    </mat-action-row>  -->
</ng-container>